import { isLocal } from "@/lib/environment";

/**
 * Sentry is off in local environments. Local sessions do not send telemetry to the cloud.
 * Gate on the app's own environment (`NEXT_PUBLIC_VIBRANT_ENV`) rather than `NODE_ENV`:
 * the local-stack E2E CI runs `next build` + `next start`, which force
 * `NODE_ENV=production` and would otherwise report every E2E-triggered error to the
 * production Sentry project. Deployed preview/sandbox/prod still report.
 * There is no env override. To test Sentry locally, change this guard and do not commit it.
 */
export function shouldInitSentry(): boolean {
  return !isLocal();
}
